import { computed, ref } from '@vue/composition-api'

import _get from 'lodash/get'
import { INPUT_TYPES_TO_FILTER_TYPES_MAP } from '@/constants/'

function _getFilterInitialValueByType (inputType) {
  // Some filters display some pretty custom components,
  // so returning '' for all of them would cause errors.
  switch (inputType) {
    case 'boolean':
      return true
    case 'days':
      return []
    default:
      return ''
  }
}

export default function useDynamicFilters (filterFields, inputTypes = ref(INPUT_TYPES_TO_FILTER_TYPES_MAP)) {
  const fieldsFormatted = computed(() => filterFields.value
    .map(field => ({
      ...field,
      label: field.label || field.name || field.questionId,
      id: `${field.name}-${field.group}`,
    }))
  )

  function getFilterById (filterId) {
    const { name, inputType, group, custom, id, questionType } = filterId ? fieldsFormatted.value.find(f => f.id === filterId) : {}
    const fallbackInputType = 'text'
    const fallbackFieldType = _get(inputTypes.value, [
      fallbackInputType,
      0,
      'key',
    ], '')
    const possibleInputType = inputType || questionType
    const possibleFieldType = _get(inputTypes.value, [
      possibleInputType,
      0,
      'key',
    ], null)

    const filterInputType = possibleFieldType ? possibleInputType : fallbackInputType

    return {
      id,
      name,
      inputType: filterInputType,
      group,
      type: possibleFieldType || fallbackFieldType,
      value: _getFilterInitialValueByType(filterInputType),
      customField: custom,
    }
  }

  return {
    getFilterById,
    fieldsFormatted,
  }
}
